<template>
    <div></div>
    <!--div class="container-footer"-->
        <!--div-->
            <!--label> Ultima actualización: 27 Mar, 2019 </label-->
        <!--/div-->
        <!--div-->
            <!--label> © 2019 Black Labs </label-->
        <!--/div-->
        <!--div-->
            <!--a href="" class="m-r-20"> FAQ </a-->
            <!--a href="" class="m-l-20"> Contact </a-->
        <!--/div-->
    <!--/div-->
</template>

<style>
</style>

<script>
    export default {
        data () {
            return {
            }
        },
        components: {
        }
    }
</script>
